<ng-template #templateRef>
    <mat-dialog-content>
        <h2 mat-dialog-title>Pick your articles
            <span class="text-right">
            <button mat-icon-button (click)="showFilters = !showFilters" type="button" id="showFilter">
                <mat-icon>filter_list</mat-icon>
            </button>
            </span>
        </h2>
        <mat-card appearance="outlined" style="margin-bottom: 50px;" [hidden]="!showFilters">
            <form #filterForm="ngForm" name="filterForm" (ngSubmit)="filter(filterForm.value)">
                <mat-card-title class="filter-title">Filter</mat-card-title>
                <mat-card-content>
                    <div class="row">
                        <div class="col-md-4">
                            <mat-form-field>
                              <mat-label>Relation code or name</mat-label>
                                <input matInput name="Name" ngModel>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <app-dropdown-option model="Relation" discriminator="RetailChain" name="RetailChain" placeholder="Chain"
                                                 multiple [getOnlyId]="true" ngModel></app-dropdown-option>
                        </div>
                        <div class="col-md-4">
                            <app-account-selector ngModel name="Representative" placeholder="Representative"></app-account-selector>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <app-group-selector ngModel name="Groups" multiple></app-group-selector>
                        </div>
                        <div class="col-md-4">
                            <app-locale-selector ngModel name="Locale" placeholder="Language"></app-locale-selector>
                        </div>
                        <div class="col-md-4">
                            <app-country-selector name="Country" ngModel [multiple]="true" [getOnlyId]="true"></app-country-selector>
                        </div>
                    </div>

                    <!-- fake button to submit form with return -->
                    <button style="display:none;"></button>
                </mat-card-content>
              <mat-card-actions>
                <div style="margin: auto">
                  <button mat-button>Filter results</button>
                  <button mat-button (click)="showFilters = false">Close</button>
                </div>
              </mat-card-actions>
            </form>
        </mat-card>
        <form #editorForm="ngForm" name="editRelation" id="articleEditor" (ngSubmit)="save()">
            <mat-tab-group>
                <mat-tab label="Search results">
                    <div class="row">
                        <table class="mat-mdc-table">
                            <tr>
                                <td>
                                    <mat-checkbox (change)="onToggleAll($event)"></mat-checkbox>
                                </td>
                                <td>Name</td>
                                <td>Code</td>
                            </tr>
                            <tr *ngFor="let rel of Relations">
                                <td>
                                    <mat-checkbox [checked]="isSelected(rel)" (change)="onToggle($event, rel)"></mat-checkbox>
                                </td>
                                <td>
                                    {{rel.Name}}
                                </td>
                                <td>
                                    {{rel.Code}}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-paginator [length]="filterObject.count" [pageSize]="filterObject.limit"
                                           [pageSizeOptions]="[5, 10, 25, 100]" (page)="pageChange($event);"></mat-paginator>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Selected ({{Selected.length}})">
                    <table class="mat-mdc-table">
                        <tr>
                            <td>Name</td>
                            <td>Code</td>
                        </tr>
                        <tr *ngFor="let rel of Selected">
                            <td>
                                {{rel.Name}}
                            </td>
                            <td>
                                {{rel.Code}}
                            </td>
                        </tr>
                    </table>
                </mat-tab>
            </mat-tab-group>
            <mat-dialog-actions>
                <div class="fill-remaining-space"></div>
                <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
                <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
            </mat-dialog-actions>
        </form>
    </mat-dialog-content>
</ng-template>
